<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">센터관리</span>
            <span class="txt">센터 기본정보를 등록하고, 관리한다.</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-tab">
                <button @click="onClickRouter('/madmin/business/center/edit')">기본정보</button>
                <button class="on">전자계약서 발송내역</button>
            </div>

            <div class="com-table-content">
                <div class="table-top-container">
                    <div class="left-box">
                        <p class="table-top-title"><strong>발송내역</strong></p>
                    </div>
                    <div class="right-box">
                        <span class="table-top-count">
                            총
                            <span class="blue">{{ this.pagingInfo.totalItems }}</span>
                            개
                        </span>
                    </div>
                </div>
                <table class="com-table">
                    <colgroup>
                        <col style="width: 100px" />
                        <col style="width: 200px" />
                        <col style="width: 170px" />
                        <col />
                        <col style="width: 170px" />
                        <col style="width: 170px" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <div class="com-check">
                                    <input
                                        id="check-all"
                                        v-model="selectedAll"
                                        name="check-all"
                                        type="checkbox"
                                        @click="checkedAll"
                                    />
                                    <label for="check-all"></label>
                                </div>
                            </th>
                            <th>
                                <button
                                    :class="sortColumn == 'cs_cre_dt' ? (sortType == 'DESC' ? '' : 'degree') : ''"
                                    @click="onClickSendDt"
                                >
                                    처리일시
                                </button>
                            </th>
                            <th>
                                <button
                                    :class="
                                        sortColumn == 'cs_contract_member_type'
                                            ? sortType == 'DESC'
                                                ? ''
                                                : 'degree'
                                            : ''
                                    "
                                    @click="onClickDivision"
                                >
                                    구분
                                </button>
                            </th>
                            <th>계약서명</th>
                            <th>발송인</th>
                            <th>PDF 다운로드</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(t, index) in contractList" :key="index">
                            <td>
                                <div class="com-check">
                                    <input
                                        :id="t.cst_id"
                                        v-model="selected"
                                        :value="index"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label :for="t.cst_id"></label>
                                </div>
                            </td>
                            <td>{{ t.cs_cre_dt | timestampFilter2 }}</td>
                            <td>{{ t.cs_contract_member_type | getContractMemberType2 }}</td>
                            <td>
                                <div style="width: 30vw">
                                    <div
                                        style="text-decoration: underline; cursor: pointer"
                                        @click="onShowContract(index)"
                                    >
                                        {{ t.ct_contract_title }}
                                    </div>
                                </div>
                            </td>
                            <td>{{ t.c_center_name }}</td>
                            <td>
                                <button class="com-btn" @click="onPDFDownload(index)">다운로드</button>
                            </td>
                        </tr>
                        <tr v-if="contractList.length === 0">
                            <td colspan="100">등록된 내역이 없습니다.</td>
                        </tr>
                    </tbody>
                </table>
                <div class="com-btn-area table-bottom-func">
                    <div class="left-box">
                        <button class="com-btn excel" @click="excelDownload()">엑셀 다운로드</button>
                        <button class="com-btn excel" @click="onPDFDownloadAll()">PDF 다운로드</button>
                    </div>
                    <div class="right-box">
                        <select-form
                            :select-data="[...sortTypeList]"
                            :select-value="[...sortTypeValueList]"
                            :selected-value="pagingInfo.limit"
                            class="float-right"
                            @update:set="changeLimit"
                        ></select-form>
                    </div>
                </div>
                <b-pagination
                    v-model="pagingInfo.page"
                    :per-page="pagingInfo.limit"
                    :total-rows="pagingInfo.totalItems"
                    align="center"
                    aria-controls="my-table"
                    first-class="first"
                    last-class="last"
                    next-class="next"
                    prev-class="prev"
                    @change="handlerPagenation($event)"
                ></b-pagination>
            </div>
        </template>

        <contract-preview-dlg
            v-if="contractPreviewPop"
            :show="contractPreviewPop"
            :templateSendId="selectedTemplateSendId"
            :close="handleCloseContractPreview"
        ></contract-preview-dlg>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import BtnLoadingSpinner from '../../../../components/BtnLoadingSpinner';
import moment from 'moment';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { convertImgToDataURLviaCanvas, pagingInfo } from '@/assets/js/common';
import ContractPreviewDlg from '../../../../components/ContractPreviewDlg';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

var JSZip = require('jszip');

export default {
    name: 'businessCenterContractList',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        ContractPreviewDlg,
    },
    props: {},
    computed: {
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
    },
    watch: {},
    created() {},
    mounted() {
        this.init();
    },
    data() {
        return {
            isLoading: false,
            pagingInfo: { ...pagingInfo },
            centerId: this.$route.params.id,

            contractList: [],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            sortColumn: 'cs_cre_dt',
            sortType: 'DESC',

            selectedAll: false,
            selected: [],

            contractPreviewPop: false,
            selectedTemplateSendId: 0,
        };
    },
    methods: {
        // 초기화
        async init() {
            this.onSearchList();
        },

        checkedAll() {
            // 전체 선택 기능
            this.selected = [];
            if (!this.selectedAll) {
                for (const i in this.contractList) {
                    this.selected.push(i);
                }
            }
        },

        onClickSendDt() {
            this.sortColumn = 'cs_cre_dt';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }

            this.onSearchList();
        },

        onClickDivision() {
            this.sortColumn = 'cs_contract_member_type';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }

            this.onSearchList();
        },

        // 한 페지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 페지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;

            this.onSearchList();
        },

        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        async onSearchList() {
            try {
                this.isLoading = true;

                const { data } = await this.getDocumentList();
                this.setPageParams(data);
                this.contractList = data.items;

                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
                console.log(error);
            }
        },
        getDocumentList(isAll = false) {
            // 스웨거: Lesson Manage Paging 목록 조회
            let params = {
                sortColumn: this.sortColumn,
                sortType: this.sortType,
                ...this.pagingInfo,
            };

            return api.get(`/admin/api/center/contract/list/${this.centerId}`, {
                params,
            });
        },

        // Excel Download
        async excelDownload() {
            const { data } = await this.getDocumentList();

            const excelDownloadArray = [];
            data.items.forEach((item) => {
                const temp = {};
                temp['처리일시'] = this.$options.filters.timestampFilter2(item.cs_cre_dt);
                temp['구분'] = this.$options.filters.getContractMemberType(item.cs_contract_member_type);
                temp['센터명'] = item.ct_contract_title;
                temp['발송인'] = item.c_center_name;

                excelDownloadArray.push(temp);
            });
            const ws = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [{ wch: 30 }, { wch: 20 }, { wch: 60 }, { wch: 30 }];
            ws['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            ws['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Contract Send List');
            XLSX.writeFile(wb, `Contract Send List ${new Date().toLocaleDateString().toString()}.xlsx`);
        },

        // 페지 이동
        onClickRouter(path) {
            this.$router.push({
                path: `${path}/${this.centerId}`,
            });
        },

        getTemplate(templateSendId) {
            return api.get(
                `/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/contract/template/send/${templateSendId}`
            );
        },

        getElementItemHtml(item, senderImageRawData, recipientImageRawData) {
            let html = ``;
            let index = 0;

            html += `
              <div class='contract-content-info'>
                    <div class='contract-title-input' style='margin-bottom: 20px; background-color: white'>
                        ${item.e_contract_title}
                    </div>
                    <div class='contract-info-title'>수신인 정보</div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>이름</div>
                        <div class='contract-info-sub-title'>${item.recipientName}</div>
                    </div>
                    <div style='display: flex'>
                        <div class='contract-info-sub-title title'>연락처</div>
                        <div class='contract-info-sub-title'>${item.recipientPhone}</div>
                    </div>`;
            if (item.centerContractId > 0 && item.centerProdId > 0) {
                const ticketInfo = JSON.parse(item.ticketInfo);
                if (ticketInfo && ticketInfo.length > 0) {
                    html += `<div class='contract-info-title'>이용권 정보</div>`;

                    ticketInfo.map((t) => {
                        html +=
                            `
                            <div class='ticket-container'>
                                <div class='ticket-box'>
                                    <div class='ticket-box-title'>` +
                            t.title +
                            `</div>
                                    <div class='ticket-box-info'>
                                        <div style='flex: 1'>
                                            ` +
                            t.period +
                            `
                                        </div>
                                        <div>
                                            ` +
                            (t.price + '원') +
                            `
                                        </div>
                                    </div>
                                </div>
                            </div>
                        `;
                    });
                }
            }

            html += `<div class='contract-info-title'>약관</div>`;

            if (item.templateInfo) {
                item.templateInfo.map((it, i) => {
                    html += `<div style='padding: 10px 10px 0 10px'>`;

                    const content = it.content.replace(new RegExp('\n', 'g'), '<br>');

                    if (it.type == 1) {
                        html += `
                        <div>
                            <div class='contract-info-sub-title' style='display: flex'>
                                <div style='flex: 1;'>${it.title}</div>
                            </div>
                            <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>
                        </div>
                      `;
                    } else {
                        html += `
                        <div style='display: flex'>
                            <div style='flex: 1;'>
                                <div class='contract-info-sub-title' style='display: flex'>
                                    <div style='flex: 1;'>${it.title}</div>
                                </div>
                                <div class='contract-info-sub-title area' style='resize: none; background-color: transparent'>${content}</div>`;

                        it.options.map((jt, j) => {
                            html += `
                            <div style='display: flex; align-items: center; margin-top: 10px'>
                                <div class='com-check'>
                                    <input
                                        :id='agree-check-${index}-${i}-${j}'
                                        name='check-c1'
                                        ` + (jt.checked ? "checked" : "") + `
                                        type='checkbox'
                                        disabled
                                    />
                                    <label :for='agree-check-${index}-${i}-${j}' class='agree-option'></label>
                                </div>
                                <div class='agree-option-input'>${jt.title}</div>
                            </div>
                          `;
                        });

                        html += `
                            </div>
                        </div>`;
                    }

                    html += `</div>`;
                });
            }

            html +=
                `
                    <div style='display: flex'>
                        <div class='contract-info-title' style='flex: 1;'>${this.$options.filters.dateFormatFilter2(
                            item.sendTime
                        )}</div>
                        <div style='width: 300px; margin-top: 40px;'>
                            <div style='display: flex; align-items: center'>
                                <div class='contract-info-person'>수신인</div>
                                <img class='contract-info-signature' src='` +
                recipientImageRawData +
                `' />
                            </div>
                            <div style='display: flex; align-items: center; margin-top: 10px;'>
                                <div class='contract-info-person'>발신인</div>
                                <img class='contract-info-signature' src='` +
                senderImageRawData +
                `' />
                            </div>
                        </div>
                    </div>
                  </div>
              `;

            return html;
        },

        getElementHtml(list, callback) {
            const item = list[0];
            let senderImageRawData = item.senderSignImageUrl;
            let recipientImageRawData = item.recipientSignImageUrl;
            // const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);
            // callback(html);
            convertImgToDataURLviaCanvas(item.senderSignImageUrl, (imageRawData) => {
                senderImageRawData = imageRawData;

                convertImgToDataURLviaCanvas(item.recipientSignImageUrl, (imageRawData) => {
                    recipientImageRawData = imageRawData;

                    const html = this.getElementItemHtml(item, senderImageRawData, recipientImageRawData);

                    callback(html);
                });
            });
        },

        getPDFContent(index, returnBuffer = false, callback = null) {
            Promise.all([this.getTemplate(this.contractList[index].cst_id)]).then((response) => {
                if (response && response.length > 0) {
                    const list = response[0].data;

                    let element = document.createElement('div');
                    element.style.padding = '20px';

                    this.getElementHtml(list, (html) => {
                        element.innerHTML = html;

                        let opt = {
                            filename: this.contractList[index].ct_contract_title + '.pdf',
                            enableLinks: true,
                            image: { type: 'jpeg', quality: 0.98 },
                            html2canvas: {
                                scale: 3,
                                y: -40,
                                scrollY: 0,
                                useCORS: true,
                                width: 800,
                                height: 1130,
                                letterRendering: true,
                            },
                            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
                        };

                        if (returnBuffer) {
                            callback(html2pdf().from(element).set(opt).output());
                        } else {
                            html2pdf().from(element).set(opt).save();
                        }
                    });
                }
            });
        },

        onPDFDownload(index) {
            this.getPDFContent(index);
        },

        onPDFDownloadAll() {
            if (this.selected.length == 0) {
                alert('계약서를 선택해 주세요.');
                return;
            } else if (this.selected.length == 1) {
                this.onPDFDownload(this.selected[0]);
                return;
            }

            const zip = new JSZip();
            let count = 0;
            this.selected.map((index) => {
                this.getPDFContent(index, true, (buffer) => {
                    count++;
                    zip.file(this.contractList[index].ct_contract_title + '_' + index + '.pdf', buffer);
                    if (count == this.selected.length) {
                        zip.generateAsync({ type: 'blob' }).then(function (content) {
                            saveAs(content, moment().format('YYYYMMDD') + '_FitToday_ContractSendList.zip');
                        });
                    }
                });
            });
        },

        onShowContract(index) {
            this.selectedTemplateSendId = this.contractList[index].cst_id;

            this.contractPreviewPop = true;
        },

        handleCloseContractPreview() {
            this.contractPreviewPop = false;
        },
    },
};
</script>
<style lang="scss"></style>
